export default function body() {

  $('.box').each(function(e) {
    $(this).on('click', function(e) {
      $('.box').not($(this)).removeClass('active');
      $(this).addClass('active');
      const id = $(this).data('id');
      $('.dot').each(function(e) {
        if($(this).data('dot-id') == id) {
          $(this).show();
        }
        else {
          $(this).hide();
        }

      })
      
      if($(window).width() > 1240 ) {
        $('.box').not($(this)).children('.path').hide();
        $(this).children('.path').show();
      }
    })
  })
}


// WEBPACK FOOTER //
// ./scripts/modules/body.js